import { Button, Icon, Message, Step } from 'semantic-ui-react';
import { AM, FINANCE, LEVEL_NAME, canApprove, fmtWhen } from '../approvals.js';

/* The two approval steps for the period on screen. Downloads appear only when both are done. */
export default function ApprovalPanel({ period, report, status, user, busy, hasFigures, onApprove, onDownload, storage }) {
  const complete = status.stage === 'complete';
  const step = (level, n) => {
    const row = status[level];
    const check = canApprove(user, level, report, status);
    const waiting = level === AM && !status.finance;
    return (
      <Step key={level} completed={!!row} active={!row && !waiting} disabled={waiting} as="div">
        <Icon name={row ? 'check circle' : 'circle outline'} color={row ? 'green' : undefined} />
        <Step.Content>
          <Step.Title>{n}. {LEVEL_NAME[level]} approval</Step.Title>
          <Step.Description>
            {row ? <span>Approved by <strong>{row.approved_by_name}</strong><br /><time dateTime={row.approved_at}>{fmtWhen(row.approved_at)}</time></span>
              : waiting ? 'Available after Finance approval' : 'Not yet approved'}
            {!row && (
              <div className="stepaction">
                <Button positive compact size="small" type="button" icon="check" labelPosition="left" content={`Approve as ${LEVEL_NAME[level]}`}
                  disabled={!check.ok || !!busy || !hasFigures} loading={busy === level} onClick={() => onApprove(level)} />
                {!check.ok && !waiting && <div className="hint">{check.reason}</div>}
                {check.ok && !hasFigures && <div className="hint">No figures in this period.</div>}
              </div>
            )}
          </Step.Description>
        </Step.Content>
      </Step>
    );
  };
  return (
    <section className="approvalpanel" aria-labelledby="appr-heading">
      <h3 id="appr-heading" className="ui small header">Approval – {period.title}</h3>
      <Step.Group fluid stackable="tablet">{step(FINANCE, 1)}{step(AM, 2)}</Step.Group>
      {complete ? (
        <div className="toolbar" role="group" aria-label="Downloads">
          <Button type="button" icon="file excel outline" labelPosition="left" content="Download Excel" loading={busy === 'xlsx'} disabled={!!busy} onClick={() => onDownload('xlsx')} />
          <Button type="button" icon="file pdf outline" labelPosition="left" content="Download PDF" loading={busy === 'pdf'} disabled={!!busy} onClick={() => onDownload('pdf')} />
        </div>
      ) : (
        <Message info size="small" role="note">Download PDF and Download Excel appear once both Finance and the Account Manager have approved this period.</Message>
      )}
      <p className="hint">Approvals are recorded with the person and the date and time, in {storage}.</p>
    </section>
  );
}
